const initState = {
    marketplaceSelectedCourse: 'none',
    courseID: 'none',
    courseObject: 'none',
    booleanMarketplaceDetailedCourseModalIsOpen: false,
    booleanMarketplaceCourseReviewsModalIsOpen: false,
    CourseHitDetails: 'empty',
    requestedCourse: 'none',

};

const marketplaceSelectedCourseReducer = (state=initState, action) => {
    
    switch (action.type) {

        case 'ADDED_COURSE_REQUEST':

            return{
                ...state,
                requestedCourse: action.requestedCourse,
            }

        case 'MARKETPLACE_ACTIONS':

            return {
                ...state,
                marketplaceSelectedCourse: action.marketplaceSelectedCourse,
                courseID: action.courseID,
                courseObject: action.courseObject,

            }


        case 'MARKETPLACE_MODAL_ACTIONS':

        return{
            ...state,
            booleanMarketplaceDetailedCourseModalIsOpen: action.booleanMarketplaceDetailedCourseModalIsOpen,
            booleanMarketplaceCourseReviewsModalIsOpen: action.booleanMarketplaceCourseReviewsModalIsOpen,
            booleanMarketplaceFlashcardReviewsModalIsOpen: action.booleanMarketplaceFlashcardReviewsModalIsOpen,
            CourseHitDetails: action.CourseHitDetails,

        }


        default:

            return state;
           
    }

}


export default marketplaceSelectedCourseReducer